import React, { Component } from "react";
import "font-awesome/css/font-awesome.min.css";
import setIcon from "../images/settings.svg";
import whatweOffer from "../images/what-we-offer.png";
import integraProcess from "../images/integration-process.png";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./AboutCLiQ.css";
import InnerVideo from "./video/video";
class AboutCliq extends Component {
  render() {
    return (
      <div className="main-container">
        <div className="container">
          <div className="row">
            <div className="col-sm-3">
              <div className="left-bar rounded h-100">
                <ul>
                  <li>
                    <Link to="/experiencezone/intergration-process">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>Integration Process</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/experiencezone/what-we-offer">
                      <img src={setIcon} alt="" className="seticon" />
                      <span>What we Offer</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="inner-content">
                <h1>About TATA CLiQ</h1>
                <p>
                  The CLiQ team aims to share knowledge with you. So CLiQ on
                  each of these icons to jump into the sessions.
                </p>
                <div className="abtInnerVideo">
                  <InnerVideo />
                </div>
                <h4>How can you become a Seller at TATA CLiQ? </h4>
                <p>
                  The e-commerce venture of Tata group follows Omni-channel
                  model, which is the most preferred format in the offline and
                  online retail industry. The platform dispenses the seller a
                  reliable and effective platform where they can sell with ease
                  through a very simple registration process.
                </p>

                <p>
                  The mode of operation followed by the company is completely
                  different from other e-commerce marketplaces. It is a curated
                  marketplace and here 100 % original products and authorized
                  sellers can prefer to sell with Tata CLIQ.The e-commerce
                  venture of Tata group follows Omni-channel model, which is the
                  most preferred format in the offline and online retail
                  industry. The platform dispenses the seller a reliable and
                  effective platform where they can sell with ease through a
                  very simple registration process.
                </p>

                <p>
                  The mode of operation followed by the company is completely
                  different from other e-commerce marketplaces. It is a curated
                  marketplace and here 100 % original products and authorized
                  sellers can prefer to sell with Tata CLIQ.
                </p>
                <p>
                  <strong>
                    Here are a few simple steps that a vendor or seller can
                    follow to register themselves with Tata CLiQ to sell their
                    products-Here are a few simple steps that a vendor or seller
                    can follow to register themselves with Tata CLiQ to sell
                    their products-
                  </strong>
                </p>
                <ul>
                  <li>
                    In order to become a seller with Tata CLiQ, you are required
                    to drop a mail to sellersupport@tataCLiQ.com. The mail
                    should contain information such as your name, email ID,
                    contact number, the category of product as well as the brand
                    name and location of your business.
                  </li>
                  <li>
                    Once you have sent the email, you will receive an automated
                    response from the e-retailer. You are now required to follow
                    up with them by dropping regular mails on the same chain
                    mail.
                  </li>
                  <li>
                    It is after this, you will receive an email from the
                    category and from here on, they will be your point of
                    contact for all processes to be onboard on TATA CLiQ.
                  </li>
                </ul>
              </div>
              <div className="inner-content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-4">
                      <Link to="/experiencezone/intergration-process" className="inner-link">
                        <h2 className="text-center">Integration Process</h2>
                      </Link>
                      <img src={integraProcess} alt="" className="inner-icon" />
                      <p className="text-center">
                        This section provides you information on integration
                        processes, documentations and steps to integrate with
                        TATA CLiQ
                      </p>
                    </div>
                    <div className="col-sm-4 offset-md-4">
                      <Link to="/experiencezone/what-we-offer" className="inner-link">
                        <h2 className="text-center">What we Offer</h2>
                      </Link>
                      <img src={whatweOffer} alt="" className="inner-icon" />
                      <p className="text-center">
                        This section includes the various Omni Channel Suites
                        that TATA CLiQ offers you. CliQ’s Training Centre
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AboutCliq;
